module.exports = __webpack_public_path__ + "media/pricing/Enterprise_PricingPage-b5a9f6bb.png";